module.exports = __webpack_public_path__ + "static/media/DL_es1.8510cf03.jpg";